import { createClient } from '@supabase/supabase-js';

// The values from your .env.local file are passed directly as strings here.
const supabase = createClient(
  "https://wnjcqclqpgqdyyomobeh.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InduamNxY2xxcGdxZHl5b21vYmVoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzNTMxNzcsImV4cCI6MjA2MzkyOTE3N30.Uab_HcvA51PG9HBmd3TKyJzQwHB8ud9mKG0gMfMeBbo"
);

export default supabase;

